import React from "react";
import T from "./../TheTool";

export default function GUI_Header(props) {
	var titleSize = T.getValue(props.label, 19);
	var descSize = T.getValue(props.descSize, 20);
	var centerDesc = T.getValue(props.centerDesc, false);

	function desc() {
		//both vers support both html tag and string (v2 is initially designed for tag)
		//e.g. props.desc_v2 = The <b>text</b>
		if(props.desc_v2 != null) { return props.desc_v2; }
		else { return centerDesc ? <center>{props.desc}</center> : props.desc; }
	}

	return (
		<div style={{ whiteSpace: "pre-line", fontSize: titleSize }}>
			<center>
				<h1>{props.title}</h1>
				<br />
			</center>
			{/* <div style={{ textAlign: "justify", fontSize: descSize }}>{props.desc}</div> */}
			<div style={{ textAlign: "justify", fontSize: descSize }}>
				{desc()}
				{/* {centerDesc ? <center>{props.desc}</center> : props.desc} */}
			</div>
		</div>
	);
}
